import Vue from "vue";

/**
 * Class User Service
 */
export default class UserService extends Vue {
    private customActions = {
        painelMessage: { method: 'GET', url: 'auth/painel-message' },
        getUserMyData: { method: 'GET', url: 'auth/user/user-my-data' },
        setUserMyData: { method: 'POST', url: 'auth/user/user-my-data' },
        onboarding: { method: 'POST', url: 'auth/user/onboarding' },
        userList: { method: 'GET', url: 'auth/user-list/{platformId}' },
        sendLoginToken: { method: 'POST', url: 'auth/login/send-login-token' },
        bonusList: { method: 'GET', url: 'auth/bonus/get-bonus' },
        saveBonusCommission: { method: 'POST', url: 'auth/bonus/store-bonus' }
    };
    private resource: any = this.$resource(
        "auth/user{/platformId}",
        {},
        this.customActions
    );

    // GET by current platform
    public show() {
        return this.resource.get();
    }

    // GET by current platform
    public userList(platformId: number) {
        return this.resource.userList({ platformId });
    }

    // STORE an user
    public store(user: UserPayload) {
        return this.resource.save({}, user);
    }

    // UPDATE an user
    public update(user: UserPayload) {
        return this.resource.update({}, user);
    }

    // GET user my data config
    public getUserMyData(userId?: number) {
        return this.resource.getUserMyData( userId ? { userId: userId } : {} );
    }
    
    // SET user my data config
    public setUserMyData(params: any) {
        params.userId = this.$auth.user().id_user;
        return this.resource.setUserMyData({}, params);
    }

    // Send recovery token via SMS
    public sendLoginToken() {
        return this.resource.sendLoginToken({});
    }
    
    public onboarding(param) {
        return this.resource.onboarding(param).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public bonusList() {
        return this.resource.bonusList();
    }

    public saveBonusCommission(param) {
        return this.resource.saveBonusCommission(param).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // GET info painel message
    public async painelMessage() {
        return await this.resource.painelMessage();
    }
    
}

interface UserPayload {
    id_user?: number,
    name: string,
    email: string,
    phone: string,
    password: string,
    profile_id: number,
    is_pj: boolean,
    platform_id: number
  }